import { Col, Row, Typography } from 'antd'
import { PRC_RATING_GUIDE } from './prcFlow'

const { Text } = Typography

export default function PrcRatingGuideDescription () {
  return (
    <div style={{ fontSize: 12 }}>
      <Text strong>个人总体评价 Employee Overall Evaluation</Text>
      <Row gutter={[16, 8]} style={{ marginTop: 8 }}>
        {PRC_RATING_GUIDE.map(item => (
          <Col span={4} key={item.code}>
            <Text strong>{item.code}:</Text> {item.range}
          </Col>
        ))}
      </Row>
    </div>
  )
}
